// Coordinate helpers for chunked world space
/**
 * @typedef {{cx:number, cy:number}} ChunkCoords
 * @typedef {{x0:number,y0:number,x1:number,y1:number}} ChunkBounds
 */

export function floorDiv(a, b) {
  const q = Math.trunc(a / b);
  const r = a % b;
  return (r !== 0 && ((r > 0) !== (b > 0))) ? q - 1 : q;
}

/**
 * Convert world tile coordinates to chunk coordinates.
 * @param {{x:number,y:number}} param0
 * @param {number} chunkSize
 * @returns {ChunkCoords}
 */
export function worldToChunk({ x, y }, chunkSize) {
  return { cx: floorDiv(x, chunkSize), cy: floorDiv(y, chunkSize) };
}

/**
 * Stable string key for a chunk coordinate.
 * @param {ChunkCoords} param0
 * @returns {string} e.g. "cx,cy"
 */
export function chunkKey({ cx, cy }) {
  return `${cx},${cy}`;
}

/**
 * Compute inclusive-exclusive world bounds for a chunk.
 * @param {ChunkCoords} param0
 * @param {number} chunkSize
 * @returns {ChunkBounds}
 */
export function chunkBounds({ cx, cy }, chunkSize) {
  const x0 = cx * chunkSize;
  const y0 = cy * chunkSize;
  const x1 = x0 + chunkSize; // exclusive
  const y1 = y0 + chunkSize; // exclusive
  return { x0, y0, x1, y1 };
}

export function worldToLocal({ x, y }, { cx, cy }, chunkSize) {
  const lx = x - cx * chunkSize;
  const ly = y - cy * chunkSize;
  return { lx, ly };
}

export function localKey(lx, ly) {
  return `${lx},${ly}`;
}
